import React from 'react';
import { Modal as SkunexusModal } from '@skunexus/component-catalog';

function RepushProductsModal(props) {
    const {
        isOpen = false,
        isLoading = false,
        headerLabel = 'Confirm Products to repush',
        onClose = () => {},
        onConfirm = () => {},
        products = [],
    } = props;

    return (
        <SkunexusModal
            isOpen={isOpen}
            isLoading={isLoading}
            headerLabel={headerLabel}
            cancelOnClick={onClose}
            confirmOnClick={() => onConfirm(products)}
        >
            <p>Are you sure you want to repush the following products?</p>
            <ul>
                {products.map((product) => (
                    <li key={product.id}>
                        {product.name} (SKU:{product.sku})
                    </li>
                ))}
            </ul>
        </SkunexusModal>
    );
}

export default RepushProductsModal;
